import React, { useEffect, useRef, useState } from "react"
import { useKeyPressEvent } from "react-use"

import { useMenu } from '@ubnt/store.core/lib/contexts/MenuContext';
import { useLockBodyScrollCustom } from "../../../hooks/useLockBodyScrollCustom"
import { theme } from "../../../layout"
import * as S from "./Overlay.styles"

// Use z indexes set in theme
const OverlayZIndexes = {
  searchOverLay: theme.zIndex.searchOverLay,
  modalOverlay: theme.zIndex.modalUnderlay,
}

export const Overlay = function Overlay() {
  const { showSearchOverlay, handleShowSearchOverlay } = useMenu() as any;

  const [overlayActive, setOverlayActive] = useState(false);
  const [overlayZIndex, setOverlayZIndex] = useState(
    OverlayZIndexes.modalOverlay
  );

  const ref = useRef(null);

  //close side nav and search tab when overlay click
  const handleOnOverlayClick = () => {
    if (showSearchOverlay) handleShowSearchOverlay(false);
  };

  useKeyPressEvent("Escape", handleOnOverlayClick);

  useEffect(() => {
    //set overlay active when side nav open or search tab active
    setOverlayActive(showSearchOverlay);

    setOverlayZIndex(
      showSearchOverlay
        ? OverlayZIndexes.searchOverLay
        : OverlayZIndexes.modalOverlay
    );
  }, [showSearchOverlay]);

  // Lock scroll when active
  useLockBodyScrollCustom(overlayActive);

  return (
    <S.OverlayContainer
      $show={overlayActive}
      $zIndex={overlayZIndex}
      ref={ref}
      onClick={handleOnOverlayClick}
    />
  );
};
